import type { ReactNode } from 'react'

import { ActionInfo } from './ActionInfo'
import './formControls.css'

/**
 * Раскрывающийся блок на `<details>`: клавиатура и диктор — встроенные. `defaultOpen` — открыт при первой
 * отрисовке. `actionId` — ⓘ строкой над блоком (блок с кнопками внутри оборачивать вручную не нужно).
 */
export function Disclosure({
  summary,
  children,
  defaultOpen = false,
  className,
  actionId,
}: {
  summary: ReactNode
  children: ReactNode
  defaultOpen?: boolean
  className?: string
  actionId?: string
}) {
  const block = (
    <details className={className === undefined ? 'krp-disclosure' : `krp-disclosure ${className}`} open={defaultOpen ? true : undefined}>
      <summary>{summary}</summary>
      {children}
    </details>
  )
  if (actionId === undefined) return block
  return (
    <ActionInfo id={actionId} layout="block">
      {block}
    </ActionInfo>
  )
}
